import { useState } from 'react';
import './App.css';
import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
// import Alert from './components/Alert';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Footer from './components/Footer';
import PasswordGenerator from './components/PasswordGenerator';

function App() {
  const [mode, setMode] = useState('light');
  // const [alert, setAlert] = useState(null);

  // const showAlert = (message, type) => {
  //   setAlert({
  //     msg: message,
  //     type: type
  //   })
  //   setTimeout(()=>{
  //     setAlert(null);
  //   }, 2000);
  // }

  const toggleMode = ()=> {
    if(mode === 'light'){
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      // showAlert("Dark mode has been Enabled", "success");
    }else{
      setMode('light');
      document.body.style.backgroundColor = 'white';
      // showAlert("Light mode has been Enabled", "success");
    }
  }

  const changeBackground = (background)=> {
    if(background === 'primary'){
      document.body.style.backgroundColor = '#0D6EFD';
      // showAlert("Primary Background Mode is enabled", "success");
    }else if(background === 'secondary'){
      document.body.style.backgroundColor = '#6C757D';
      // showAlert("Secondary Background Mode is enabled", "success");
    }else if(background === 'success'){
      document.body.style.backgroundColor = '#198754';
      // showAlert("Success Background Mode is enabled", "success");
    }else if(background === 'danger'){
      document.body.style.backgroundColor = '#DC3545';
      // showAlert("Danger Background Mode is enabled", "success");
    }else if(background === 'warning'){
      document.body.style.backgroundColor = '#FFC107';
      // showAlert("Warning Background Mode is enabled", "success");
    }else if(background === 'info'){
      document.body.style.backgroundColor = '#0DCAF0';
      // showAlert("Info Background Mode is enabled", "success");
    }else{
      document.body.style.backgroundColor = 'white';
      // showAlert("Light mode has been Enabled", "success");
    }
  }

  return (
    <>
    {/* <Navbar title="ZeeUtils" aboutText="About ZeeUtils" /> */}
    {/* <Navbar/> */}
    <Router>
      
      <Navbar title="ZeeUtils" mode={mode} toggleMode={toggleMode} changeBackground={changeBackground} />
      
      <div className="container mt-5 mb-5">
        {/* <Alert alert={alert} /> */}
        <Switch>
          <Route exact path="/about">
            <About title="ZeeUtils - About" mode={mode} />
          </Route>
          <Route exact path="/password-generator">
            <PasswordGenerator title="ZeeUtils - Password Generator" mode={mode} />
          </Route>
          <Route exact path="/">
            {/* <TextForm title="ZeeUtils - Home" showAlert={showAlert} heading="Try ZeeUtils - Word Counter, Character Counter, Remove Extra Spaces" mode={mode} /> */}
            <TextForm title="ZeeUtils - Home" heading="ZeeUtils Is Your One-stop Solution For All Your Text Processing Needs." mode={mode} />
          </Route>
        </Switch>
      </div>

      <Footer mode={mode} />

    </Router>
    </> 
  );
}

export default App;
